import fetch from "isomorphic-fetch";
import { fetch as router } from "helpers/router";
import request from "utils/request";
import { csrf } from "utils/requestHeaders";

// Helpers ----------------------

// the response either directly returns the data or wraps it in a data property
const getResponseData = (response) => response.data || response;

// Actions ----------------------

export const SUBMIT = "fundraiser-signup/SUBMIT";
export const submit = () => ({
  type: SUBMIT,
});

export const SUBMIT_SUCCESS = "fundraiser-signup/SUBMIT_SUCCESS";
export const submitSuccess = (json) => ({
  type: SUBMIT_SUCCESS,
  data: json || [],
});

export const SUBMIT_ERROR = "fundraiser-signup/SUBMIT_ERROR";
export const submitError = (error) => ({
  type: SUBMIT_ERROR,
  error,
});

export const SEND_LINK = "fundraiser-signup/SEND_LINK";
export const sendLink = () => ({
  type: SEND_LINK,
});

export const SEND_LINK_SUCCESS = "fundraiser-signup/SEND_LINK_SUCCESS";
export const sendLinkSuccess = (json) => ({
  type: SEND_LINK_SUCCESS,
  data: json || [],
});

export const SEND_LINK_ERROR = "fundraiser-signup/SEND_LINK_ERROR";
export const sendLinkError = (error) => ({
  type: SEND_LINK_ERROR,
  error,
});

export const MODAL_STATUS = "fundraiser-signup/MODAL_STATUS";
export const modalStatus = (data) => ({
  type: MODAL_STATUS,
  data,
});

export const MODAL_TYPE = "fundraiser-signup/MODAL_TYPE";
export const modalType = (data) => ({
  type: MODAL_TYPE,
  data,
});

export const EXISTING_USER = "fundraiser-signup/EXISTING_USER";
const existingUser = (data) => ({
  type: EXISTING_USER,
  data,
});

export const BAD_PASSWORD = "fundraiser-signup/BAD_PASSWORD";
const badPassword = (data) => ({
  type: BAD_PASSWORD,
  data,
});

export const BAD_TEAM = "fundraiser-signup/BAD_TEAM";
const badTeam = (data) => ({
  type: BAD_TEAM,
  data,
});

export const GENERIC_ERROR = "fundraiser-signup/GENERIC_ERROR";
const genericError = (responseData) => ({
  type: GENERIC_ERROR,
  responseData,
});

export const submitSignup = (data) => (dispatch) => {
  const campaign = window.Chuffed.signupInit.campaignId;
  let url = router("api.v2.campaign.fundraiser.signup", { campaign });
  const formData = data;
  if (formData.team_target > 0) {
    formData.team_target = Math.round(formData.team_target);
  }
  if (data.hasOwnProperty("action") === true) {
    url = router("api.v2.campaign.fundraiser.email-link", { campaign });

    if (data.action === "email-link") {
      dispatch(sendLink());
    }
  } else {
    dispatch(submit());
  }

  const req = request(url, "POST", csrf(document), formData);

  return new Promise((resolve, reject) => {
    fetch(req)
      .then((response) => response.json())
      .then((json) => {
        const responseData = getResponseData(json);
        if (responseData.success === true) {
          if (data.hasOwnProperty("action") === true) {
          // If successfully sent the send link action, show thank you
            if (data.action === "email-link") {
              dispatch(sendLinkSuccess());
            }
          } else if (responseData.action === "email-link") {
            dispatch(sendLinkSuccess());
          } else {
            // Otherwise update state with fundraiser data from response, show thank you
            dispatch(submitSuccess(responseData));
          }

          resolve(responseData);
        } else if (responseData.error === "Existing user") {
          dispatch(existingUser(data));
        } else if (responseData.error === "Bad password") {
          dispatch(badPassword(data));
        } else if (responseData.error === "Team not found") {
          dispatch(badTeam(data));
        } else if (responseData.errors !== undefined) {
          dispatch(genericError(responseData, data));
        } else if (data.hasOwnProperty("action") === true) {
          if (data.action === "email-link") {
            dispatch(sendLinkError(responseData));
          }
        } else {
          dispatch(submitError(responseData));
        }
      })
      .catch((error) => {
        dispatch(submitError(error));
        reject(error);
      });
  });
};
